type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  variant?: "tertiary" | "secondary" | "warning";
  size?: "small" | "regular" | "full";
  disabled?: boolean;
  actif?: boolean;
};

export const Button = ({
  children,
  onClick,
  className = "",
  type = "button",
  variant = "tertiary",
  size = "regular",
  disabled = false,
  actif = true,
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`
        font-oxaniumMedium
        rounded-lg
        uppercase
        tracking-wider
        hover:opacity-90
        transition-opacity
        ${
          variant === "tertiary"
            ? "bg-tertiary text-secondary-text"
            : variant === "warning"
              ? " !bg-red-50 hover:!bg-red-100 !border-red-200 !text-red-600"
              : "bg-secondary text-secondary-text"
        }
        ${!actif && "bg-grey-light"}
        ${
          size === "full"
            ? "text-base w-full py-2"
            : size === "small"
              ? "text-sm px-3 py-1"
              : "text-base px-6 py-2"
        }
        ${className}
      `}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
